<template>
  <div class="rounded-full border-2 border-t-primary h-12 w-12 animate-spin" />
</template>
